import { connect } from 'react-redux';
import { toggleOverduePrompt } from '../../../../store/account/actions';
import OverduePromptComponent from '../../components/OverduePrompt/OverduePrompt';

const mapStateToProps = ({ account }) => {
  const { overdueDays, isShowOverduePrompt, isLogin } = account;
  return {
    overdueDays,
    isShowOverduePrompt,
    isLogin
  };
};

const mapDispatchToProps = {
  toggleOverduePrompt
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OverduePromptComponent);
